import React, { Component } from 'react';
import { Link } from 'react-router';
import '../styles/Nav.scss';
import initialsSVG from '../../public/images/svg/initials.svg';
import SVG from './SVG';

class Nav extends Component {
  constructor() {
    super();

    this.defaultColor = 'white';
    this.colorIndex = 0;
    this.colors = [
      '#B90EFF',
      '#0A63E8',
      'rgb(0, 176, 240)',
      '#3CFF10',
      '#E8DB14',
      '#FFA124',
      '#FF2746'
    ];

    this.state = {
      initialsColor: this.defaultColor
    };

    this.startAnimation = this.startAnimation.bind(this);
    this.stopAnimation = this.stopAnimation.bind(this);
  }

  animateInitials() {
    this.colorIndex++;
    if (this.colorIndex > this.colors.length - 1) this.colorIndex = 0;
    const nextColor = this.colors[this.colorIndex];
    this.setState({ initialsColor: nextColor });
  }

  startAnimation() {
    this.animateInitials();
    this.animationInterval = setInterval(this.animateInitials.bind(this), 500);
  }

  stopAnimation() {
    clearInterval(this.animationInterval);
    this.setState({ initialsColor: this.defaultColor });
  }

  componentWillUnmount() {
    this.stopAnimation();
  }

  render() {
    return (
      <nav className="Nav">
        <div className="top-bar" />
        <Link to="/" className="bug" onMouseEnter={this.startAnimation} onMouseLeave={this.stopAnimation}>
          <SVG file={initialsSVG} name="initials" />
          <style type="text/css">
            {`.Nav .initials * { fill: ${this.state.initialsColor}; }`}
          </style>
        </Link>
        <div className="title">
          <div className="bg" />
          <p>{this.props.title}</p>
        </div>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js